// @flow
import axios from 'lib/defaultClient';

export const getTags = (sort: string = 'popular') => {
  return axios.get(`/common/tags?sort=${sort}`);
};

export const getTagInfo = (tag: string) => {
  return axios.get(`/common/tags/${tag}`);
};

export const getSections = () => {
  return axios.get(`/common/sections`);
};

export const getSectionInfo = (section: string) => {
  return axios.get(`/common/sections/${section}`);
};

export const getProductsTags = (sort: string = 'popular') => {
  return axios.get(`/common/products/tags?sort=${sort}`);
};

export const getProductsTagInfo = (tag: string) => {
  return axios.get(`/common/products/tags/${tag}`);
};

export const getCategories = (sort: string = 'popular') => {
  return axios.get(`/common/categories?sort=${sort}`);
};

export const getCategoryInfo = (category: string) => {
  return axios.get(`/common/categories/${category}`);
};

export type CreateGeneralUploadUrlPayload = { refId?: string, filename: string, type: string };

export const createGeneralUploadUrl = ({
  refId,
  type,
  filename,
}: CreateGeneralUploadUrlPayload) => {
  return axios.post('/files/create-url/general', { ref_id: refId, filename, type });
};

export const createPublicUploadUrl = ({ refId, type, filename }: CreateGeneralUploadUrlPayload) => {
  return axios.post('/files/create-url/public', { ref_id: refId, filename, type });
};



// WEBPACK FOOTER //
// ./src/lib/api/common.js